import React, { useEffect, useState } from 'react';
import { Col, Row } from 'twyne-new.ui';
import Moment from 'moment-timezone';
import queryString from 'query-string';

import appStore from 'stores/app';
import history from './history';

export const defaultDateTimeFormat = 'MM/DD/YYYY [at] hh:mm A'

export function useQueryparams(clear) {
  const [params, setParams] = useState(null)

  useEffect(() => {
    try {
      const params = queryString.parse(history.location.search);
      setParams(params)

      if (clear)
        history.replace({ search: '' })

    } catch (e) { }
  }, [])

  return params
}

export const formatDateTime = (dateTime, format = defaultDateTimeFormat) => {
  if (dateTime) {
    return Moment(dateTime).tz(appStore.timezone).format(format);
  }
  return '';
};

export const formatDate = (date, mask = 'MM/DD/YYYY') => {
  if (date) {
    return Moment(date).tz(appStore.timezone).format(mask);
  }
  return '';
};

export const getDateFormats = (key) => ([
  `${key}_dd`,
  `${key}_mm`,
  `${key}_yyyy`,
  `${key}_yyyyddmm`,
  `${key}_slashes_mmddyyyy`,
  `${key}_dashes_mmddyyyy`
])

export const randomID = () => {
  return Math.random().toString(36).split('.')[1];
};


export const nameAndCreateDateFormatter = (dataField) => {
  return (cell, row) => {
    return <Col>
      <Row>{row[dataField]}</Row>
      <Row><small style={{ color: "#b3b8bb" }}>Created at: {formatDateTime(row.created_at)}</small></Row>
    </Col>
  }
}

export const nameWithCreateDateAndUserFormatter = dataField => (cell, row) => <Col>
  <Row>{row[dataField]}</Row>
  <Row><small style={{ color: "#b3b8bb" }}>Created at: {formatDateTime(row.created_at)} by {row.user.first_name} {row.user.last_name}</small></Row>
</Col>

export const mapping = (k, v) => (mapping, { [k]: key, [v]: value }) => ({ ...mapping, [key]: value })

export const sanitizeCustomFieldAnswer = value => value.replace(/[}{)('"|,$]/g, '')

export const titleOptions = [
  { "label": "Mr.", "value": "M" },
  { "label": "Ms", "value": "F" },
  { "label": "Mrs", "value": "F" }
]

export const stateOptions = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District Of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]

const currentYear = (new Date()).getFullYear()
export const dobYearOptions = (agemin, agemax) => Array(agemax - agemin + 1)
  .fill(null)
  .map((_, i) => {
    const year = currentYear - agemin - i
    return { label: `year "${year}"`, value: year }
  })
